'use es6';

import { hubletApi } from 'hub-http/middlewares/core';
import http, { noAuthClient } from '../../lib/utils/httpClient';
const API_CATALOG_PUBLIC_BASE = '/api/api-catalog-public/';
export function fetchSpecification(endpoint) {
  return http.get(`${API_CATALOG_PUBLIC_BASE}${endpoint}`, {
    query: {
      swaggerVersion: 3
    },
    // API_CATALOG_PUBLIC_BASE is only deployed to the na1 hublet
    api: hubletApi('app', 'hubspot', 'na1')
  });
}
export function fetchCustomSpecification(url, isInternal) {
  return isInternal ? http.get(url) : noAuthClient.get(url, {
    withCredentials: false
  });
}